import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-widgets/dist/css/react-widgets.css';

import './index.css';
import SPA from './SPA';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <SPA />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
